import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AuthPagesDescription = () => {
  const navigate = useNavigate();
  return (
    <Box p={1}>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={8}
      >
        <img
          src={require("assets/img/png/Logo_new.png")}
          className="logo"
          alt=""
          style={{margin: "auto 0", alignSelf: "flex-start", cursor: "pointer", width: "122px", height: "39px" }}
          onClick={() => navigate("/")}
        />
        <Typography sx={{ fontSize: "30px", color: "common.white" }}>
          Book a Tractor, Attachment or Any other Equipment
        </Typography>
        <Typography sx={{ fontSize: "13.5px", color: "common.white" }}>
          Explore a hassle-free way to access top-notch agricultural and
          industrial equipment with our convenient booking service.
        </Typography>
        <Typography
          sx={{
            fontSize: "13.5px",
            color: "common.white",
            alignSelf: "flex-start",
          }}
        >
          <span
            style={{ cursor: "pointer",marginRight: "5px" }}
            onClick={() =>window.open(`https://us-central1-haystackers-84f94.cloudfunctions.net/api/v1/public/Haystackers%20T&C.pdf`, "_blank")
           
            }
          >
            Terms Of Service
          </span>{" "}
          •
          <span
            style={{ cursor: "pointer" , marginLeft: "5px"}}

            onClick={() =>window.open(`https://us-central1-haystackers-84f94.cloudfunctions.net/api/v1/public/Haystackers%20Privacy%20Policy%20and%20CA%20Privacy%20Policy.pdf`, "_blank")
           
          }
           
          >
            Privacy Policy
          </span>
        </Typography>
      </Stack>
    </Box>
  );
};

export default AuthPagesDescription;
